import { API_URL } from '../../utils/constants';

import request from '../request';

export default {
  // get: async (id) => {
  //   return request(`${API_URL}/products/generics/${id}`, 'get', {}, {});
  // },
  update: async (id, values) => {
    const body = JSON.stringify(values);
    return request(`${API_URL}/products/supplier-products/${id}`, 'put', body);
  },
  create: async (values) => {
    const body = JSON.stringify(values);
    return request(`${API_URL}/products/supplier-products/`, 'post', body);
  },
  delete: async (id) => {
    return request(`${API_URL}/products/supplier-products/${id}`, 'delete');
  },
  // createRemove: async (id, packageIds) => {
  //   const body = JSON.stringify(packageIds);
  //   return request(`${API_URL}/products/packaged-products/${id}`, 'post', body);
  // },
};
